<template>
  <div class="container-fluid">
    <div
      v-if="!loading"
      class="row animate__animated animate__fadeIn animate__faster">
      <div
        class="col-12 pt-2 sticky-top text-center"
        style="background: white; border-bottom: 1px solid lightgray;">
        <!-- Step Back -->
        <button
          class="btn btn-sm btn-primary float-start animate__animated animate__bounceIn animate__faster"
          @click="back">
          <i class="fa fa-chevron-left"/>
          Back
        </button>
        <h3 v-if="mfgList && mfgList.length">Select a Manufacturer</h3>
      </div>
      <div
        v-if="!mfgList || mfgList && !mfgList.length"  
        class="col-12 text-center p-2 mt-5">
        <h2 class="text-muted">
          No Data
        </h2>
      </div>
      <!-- MFG Cards -->
      <div
        v-if="mfgList"
        class="container">
        <div class="row mt-2">
          <div
            v-if="loading"
            class="col-12 text-center mt-5">
            <Spinner/>
          </div>
          <template
            v-else-if="mfgFilteredList.length"
            v-for="(m,i) in mfgFilteredList"
            :key="i">
            <MfgCard :mfg="m"/>
          </template>
          <template v-else>
            <div class="text-center text-muted mt-5">
              <h4>No Results</h4>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div
      v-else
      class="row">
      <div class="col-12 text-center mt-5">
        <Spinner/>
      </div>
    </div>
  </div>
</template>

<script setup>
  import MfgCard from './components/MfgCard.vue';
  import Spinner from '../../../../global/Spinner.vue';
  import { ref, computed, onBeforeMount, onMounted } from 'vue';
  import { useStore } from 'vuex';

  // Initialize
  const store = useStore()

  // LifeCycle
  onBeforeMount(()=>{
    store.dispatch('getDropshipMfgList')
  })

  onMounted(()=>{
    store.dispatch('dropshipClearQuery')
  })


  const back = ()=>{
    store.dispatch('stepBack')
  }

  /* Computed */

  const dropshipQuery = computed(()=>{
    return store.getters.dropshipQuery
  })

  // Perform mfg search if query string present
  const mfgFilteredList = computed(()=>{

    // Sey query string
    const query = dropshipQuery.value.toLowerCase()
    
    // Search mfg/vendor names
    const base = (mfg)=>{
      return mfg.mfg.toLowerCase().includes(query)
    }

    // Search mfg/vendor buyline description
    const buylineSearch = (mfg)=>{
      return _.map(mfg.buylines, b => b.description.toLowerCase()).toString().includes(query)
    }

    // Search customer super buyline name
    const superBuylineName = (mfg)=>{
      if(!mfg.super_buyline) return
      return mfg.super_buyline_name.toLowerCase().includes(query)
    }
    
    // Perform Filtering
    if(mfgList.value && dropshipQuery.value.length){
      return _.filter(mfgList.value, m=>{
        if(m.buylines) return base(m) || buylineSearch(m) || superBuylineName(m)
        return base(m)
      })
    }
    
    return _.orderBy(mfgList.value, 'mfg')
  })
  
  // Manufacturer name and logo list
  const mfgList = computed(()=>{
    return store.getters.dropshipMfgList
  })

  // Loading Status
  const loading = computed(()=>{
    return store.getters.dropshipLoading
  })
</script>